/* eslint-disable max-params */
import React, { ReactNode } from "react";
import ReactDOM from "react-dom";
import Revoke from "@/components/chat/message/Revoke";
import Text from "@/components/chat/message/Text";
import HttpCard from "@/components/chat/message/HttpCard";
import Image from "@/components/chat/message/Image";
import UploadFile from "@/baseComponents/Chat/message/File/Upload";
import DownloadFile from "@/baseComponents/Chat/message/File/Download";
import Video from "@/components/chat/message/Video";
import Voice from "@/components/chat/message/Voice";
import Share from "@/components/chat/message/share";
import NoticeCard from "@/components/chat/message/NoticeCard";
import AINoticeCard from "@/components/chat/message/AINoticeCard";
import SysMessage from "@/components/chat/message/Sys";
import Location from "@/components/chat/message/Location";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import IconFont from "@/components/icon";
import PreviewImage from "../message/Preview/web/view_3";
import { changeEgovUrl } from "@/utils/tools";
import {
  ChatMessageType,
  Employee,
  FileChatMessage,
  JoySpaceDocumentMessage,
  Session,
  TextChatMessageExt,
  VideoMessage,
  ImageChatMessage,
  VideoChatMessage,
  MessageStatus
} from "@/types/chat";
import { MessageDateFormType, MessageSendType } from "@/types/chat/enum";
import { getMessageDateFormat } from "@/utils/date";
import {
  buildTemplate2MessageBody,
  checkMessageSupport,
  convertContentToArray,
  convertEmployeeToString,
  isEqualEmployee,
  isSameClient,
  MessageCardType
} from "@/utils/chat/message";
import JoyspaceFile from "../message/message-components/JoyspaceFile";
import {
  formatAtUser,
  getFileUrl,
  mattchUrl,
  stringEncode,
  getMessageFileName,
  checkDownloadFilePathValid,
  getFileFilter,
  downLoadFile,
  getDownloadFileResp
} from "@/utils/chat/index";
import { convertStringToEmoji } from "@/components/chat/utils/ddemoji";
import { deleteEmojiStr, mattchEmoji } from "@/components/chat/message/Input/Emoji";
import { detectOS, DownloadItem, FocusSDK, getUser, isFocusEnv } from "@/utils";
import { message as toast, Modal } from "antd";
import { openUserCardModal } from "@/components/AddressBook/common";
import lodashGet from "lodash/get";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { replaceGovUrl } from "@/utils/joyspace";
import ImService from "@/server/ImService";
import "./commonMessageModal.less";
import { addFileDownloadRecord } from "@/api/chat";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import i18n from "@/i18n";
import { debounce } from "lodash";
import JoyspaceFolder from "../message/message-components/JoyspaceFolder";
import MeetingInviteCard from "../message/Text/MeetingInviteCard";
import { addXclient } from "@/utils/addToken";
import { generateMessageId } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import CHAT_NOTICE, { TYPE_KEY_SHARE_GREET_MULTI } from "@/contant/chat";
import Remarkable, { TagToken, TextToken, Token } from "remarkable";
import { isAIChatSession } from "@/utils/chat/session";
import { hex } from "js-md5";
interface TextHighlightIProps {
  keyWord: string;
  content: string;
  sMid: number;
  mid: number;
}

export const getTextHighlightMessageContent = (props: TextHighlightIProps) => {
  const { keyWord = "", content = "", sMid = -1, mid = -1 } = props;
  const index = content.indexOf(keyWord);
  const beforeStr = content.substr(0, index);
  const afterStr = content.substr(index + keyWord.length);
  // console.log('TextHighlightIProps', props, index, 'beforeStr', beforeStr, 'afterStr', afterStr);
  // sMid === mid 只有本条消息才高亮
  const highlight =
    index > -1 && sMid !== -1 && sMid === mid
      ? `<span class="message-highlight-container">${beforeStr}<span class="message-highlight">${keyWord}</span>${afterStr}</span>`
      : `${content}`;
  return highlight;
};

/* eslint max-params: ["error", 4] */

export const getEmoji = (content: string) => {
  let result = content;
  const patt1 = /\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;

  const matchResult1 = result.match(patt1) || [];

  const NewreSet1 = new Set([...matchResult1]);

  NewreSet1.forEach((e, i) => {
    const pattern = new RegExp(e, "g");
    const ispattern = result.indexOf(e);
    if (ispattern !== -1) {
      result = result.replace(pattern, `<span class='message-emoji'>${e}</span>`);
    }
  });
  return result;
};

// 用来判断这条文本是否全是emoji 删除掉所有emoji，剩下全是空格或者为空
export const allEmoji = (content: string) => {
  const allSpace = /^\s+$/g;
  const newContent = deleteEmojiStr(content);
  let result = allSpace.test(newContent);
  if (newContent === "") {
    result = true;
  }
  return !result;
};

export const convertLink = (content: string) => {
  try {
    const rn = /<a.*?>/g;
    const c = content.replace(rn, (item) => {
      return item.replace(/<a (.*?)/, "<a target=\"_blank\" $1");
    });
    return c || "";
  } catch (e) {
    return content;
  }
};

export const convertFooterBlock = (content: string) => {
  try {
    const rn = /<([a-z]+)\s+class="footnotes(-.)?"[^>]*>([\s\S]*?<\/\1>)?/g;
    const c = content.replace(rn, (item) => {
      return item.replace(rn, "");
    });
    return c || content;
  } catch (e) {
    return content;
  }
};

export const formateMarkdownText = (content: string) => {
  try {
    const rn = /.*-$/g;
    const c = content.replace(rn, (item) => {
      return item.replace(/(.*?)-$/, "$1");
    });
    return c || "";
  } catch (e) {
    return "";
  }
};

export const getTextRemark = (content: string, msgId: string) => {
  let result = formateMarkdownText(content);
  const remark = new Remarkable({
    html: true,
    xhtmlOut: false,
    breaks: true,
    langPrefix: "language-",
    linkify: true,
    linkTarget: "_blank",
    typographer: false,
    quotes: "“”‘’"
  });
 // 覆盖脚注引用渲染（显示为纯文本标记）
 remark.renderer.rules.footnote_ref = (tokens, idx) => {
  const idNum = tokens[idx].id;
  return `<sup class="remark-footnote-ref" id="${msgId}_${idNum}" data-index="${idNum}">[${
    idNum + 1
  }]</sup>`;
};

// 隐藏脚注内容区块（直接返回空字符串）
remark.renderer.rules.footnote_anchor = () => "";
remark.renderer.rules.footnote_block_open = () => "";
remark.renderer.rules.footnote_block_close = () => "";
  remark.renderer.rules.table_open = () => "<div class=\"table-scroll-wrapper\"><table>";
  remark.renderer.rules.table_close = () => "</table></div>";
  result = formateMarkdownText(result);
  try {
    result = remark.render(result);
  } catch (e) {
    console.error(`render err`, e);
  }
  return result;
};

export const getTextMessageRemark = (
  session: Session,
  message: TextChatMessageExt,
  currentEmployee: Employee,
  sText?: string,
  sMid?: number,
  atDetail?: any
) => {
  let { atUsers, content, mid = -1 } = message;
  content = formateMarkdownText(content);
  content = stringEncode(content);
  let result = `${content}`;
  if (isAIChatSession(session)) {
    if (!isEqualEmployee(message.sender, currentEmployee)) {
      result = getTextRemark(result, message.id);
    }
  }
  result = convertLink(result);
  // result = convertFooterBlock(result);
  if (atUsers?.length && (!message?.quillJson?.length || atDetail)) {
    result = formatAtUser(result, atUsers, currentEmployee, session, atDetail);
  }
  result = convertStringToEmoji(result);
  result = mattchEmoji(result);
  result = getTextHighlightMessageContent({
    keyWord: sText || "",
    content: result,
    sMid: sMid || -1,
    mid
  });
  result = getEmoji(result);
  return result;
};

export const getSimpleTextRemark = (content: string) => {
  let result = content;
  result = formateMarkdownText(result);
  result = stringEncode(result);
  result = formateMarkdownText(result);
  const remark = new Remarkable({
    html: true,
    xhtmlOut: false,
    breaks: true,
    langPrefix: "language-",
    linkify: true,
    linkTarget: "_blank",
    typographer: false,
    quotes: "“”‘’"
  });
  remark.renderer.rules.table_open = () => "<div class=\"table-scroll-wrapper\"><table>";
  remark.renderer.rules.table_close = () => "</table></div>";
  result = formateMarkdownText(`${content}`);
  try {
    result = remark.render(result);
  } catch(e) {
    console.error(`render err`, e);
  }
  return result;
};

export const getTextMessageContent = (
  // 会话对象
  session: Session,
  // 文本聊天消息扩展对象
  message: TextChatMessageExt,
  // 当前员工对象
  currentEmployee: Employee,
  // 可选的搜索文本
  sText?: string,
  // 可选的消息ID
  sMid?: number,
  // 可选的@用户详细信息
  atDetail?: any
) => {
  // 解构消息对象，获取@用户列表、消息内容和消息ID（默认为-1）
  let { atUsers, content, mid = -1 } = message;

  // 对消息内容进行编码处理
  content = stringEncode(content);

  // 在消息内容中查找并格式化URL链接
  let result = mattchUrl(content);

  // 如果存在@用户并且消息没有Quill JSON格式或需要显示@用户详细信息
  if (atUsers?.length && (!message?.quillJson?.length || atDetail)) {
    // 对消息内容进行@用户格式化处理
    result = formatAtUser(result, atUsers, currentEmployee, session, atDetail);
  }

  // 将消息内容中的字符串转换为表情符号
  result = convertStringToEmoji(result);

  // 在消息内容中查找并格式化表情符号
  result = mattchEmoji(result);

  // 根据搜索文本、消息内容、消息ID和关键字进行高亮处理
  result = getTextHighlightMessageContent({
    keyWord: sText || "",
    content: result,
    sMid: sMid || -1,
    mid
  });

  // 获取并添加表情符号到消息内容中
  result = getEmoji(result);

  // 返回处理后的消息内容
  return result;
};

// 提示语消息体
export const getShareHintMessageBody = async (
  currentEmployee: Employee,
  cardInfo: any
): Promise<any> => {
  const {
    prefix = "您好，我是小办，您的智能办公助理！期待为您提供咨询服务。",
    rec_questions = [],
    carouselList = [],
    aiPreviewLink = ""
  } = cardInfo;
  const dataCard = [];
  // 轮播图
  // if (carouselList) {
  //   dataCard.push({
  //     nativeId: "share_greet_carousel",
  //     data: carouselList,
  //     id: generateMessageId()
  //   });
  // }
  // 指引
  const guides = [
    {
      content: prefix,
      link: aiPreviewLink
    }
  ];
  dataCard.push({
    nativeId: "share_guide_card",
    data: guides,
    id: generateMessageId()
  });
  if (rec_questions) {
    dataCard.push({
      nativeId: "share_recommend_qa",
      data: rec_questions,
      id: generateMessageId()
    });
  }
  const data = {
    data: dataCard,
    id: hex(TYPE_KEY_SHARE_GREET_MULTI),
    timestamp: new Date().getTime()
  };
  const from = {
    app: currentEmployee.app,
    teamId: currentEmployee.teamId,
    pin: CHAT_NOTICE.AI_CHAT_PIN
  };
  return {
    ...buildTemplate2MessageBody(data),
    content: "",
    mid: 0,
    type: TYPE_KEY_SHARE_GREET_MULTI,
    category: "chat_message",
    sender: await ImService.getInstance()?.getUserFromLocal({
      app: currentEmployee.app,
      teamId: currentEmployee.teamId,
      pin: CHAT_NOTICE.AI_CHAT_PIN
    }),
    from
  };
};
const netServer = NetworkCheck.getInstance({
  url: getNetCheckUrl(),
  checkType: UseCheckType.API
});
const debounceOpenPreviewWindow = debounce((opts, token) => {
  // FocusSDK.printLog("预览图片webapp：sendMessage to desktop", JSON.stringify(opts));
  FocusSDK.sendIpcMessage("image:openImagePreviewWindow", {
    ...opts,
    token
  });
}, 500);
export const getPreviewImageModal = async ({
  message,
  isMergeForward,
  isInviteForward,
  modalMessages,
  notPreviewText,
  noPreAndNext
}: {
  message: any;
  isMergeForward?: boolean;
  isInviteForward?: boolean;
  modalMessages?: any[];
  notPreviewText?: boolean;
  noPreAndNext?: boolean;
}) => {
  let previewImgVisible = false;
  if (isFocusEnv()) {
    const onLine = await netServer.checkNet();
    if (!onLine) {
      return toast.error(i18n.t("Network Error"));
    }
    let opts;
    if (isMergeForward || isInviteForward) {
      const filterModalMessages: any[] = [];
      modalMessages?.forEach((item: any) => {
        if (item.kind === ChatMessageType.TEXT || item.type === ChatMessageType.TEXT) {
          if (item?.quillJson) {
            const content =
              typeof item.quillJson === "string" ? JSON.parse(item.quillJson) : item.quillJson;
            for (const value of content) {
              const insert = value.insert;
              if (insert && insert?.image) {
                const img = insert.image;
                filterModalMessages.push({
                  fileName: img.title,
                  url: img.url,
                  id: `${item.mid || (item as any).muuid}-${img.imageId}`,
                  size: img.size || 0,
                  viewOriginal: true,
                  fileMd5: img.fileMd5,
                  imageId: img.imageId
                });
              }
            }
          }
        } else if (item.kind === ChatMessageType.IMAGE || item.type === ChatMessageType.IMAGE) {
          filterModalMessages.push({
            fileName: item.fileName,
            url: item.url,
            id: isInviteForward ? item.mid : item.muuid,
            size: item.size || 0,
            viewOriginal: !!item.viewOriginal
          });
        }
      });

      const currentImageIndex = filterModalMessages?.findIndex(
        (item) =>
          item.id === message?.imageId ||
          item.id === (isInviteForward ? message?.mid : message?.muuid)
      );
      opts = {
        isMergeForward: true,
        curIndex: currentImageIndex,
        filterModalMessages: JSON.stringify(filterModalMessages),
        fileMd5: message.fileMd5,
        imageId: message.imageId
      };
    } else {
      opts = {
        sessionId: message.sessionId,
        id: message.mid,
        fileName: getMessageFileName(message),
        fileUrl: message.url,
        size: message.size || 0,
        viewOriginal: !!message.viewOriginal,
        timestamp: message.timestamp,
        notPreviewText: notPreviewText,
        noPreAndNext: noPreAndNext,
        quillJson: message.quillJson,
        fileMd5: message.fileMd5,
        imageId: message.imageId
      };
    }
    const info = await getUser();
    // 防抖处理，一定时间内只触发一次sendMsg，防止用户快速点击多个图片，viewer生成多个
    debounceOpenPreviewWindow(opts, info.accessToken);
  } else {
    // web端预览图片
    previewImgVisible = true;
  }
  const args = message?.sessionId?.split(":") || [];
  let isDownload = true;
  if (args.length > 6 && args[6] === "secret") {
    isDownload = false;
  }
  const ele = document.createElement("div");
  document.body.appendChild(ele);
  const MyModal = (
    <Modal
      title="图片预览"
      destroyOnClose={true}
      footer={null}
      keyboard={false}
      mask={false}
      visible={previewImgVisible}
      width="100%"
      wrapClassName="web-preview-image-modal"
      zIndex={1900}
    >
      {previewImgVisible && (
        <PreviewImage
          fileName={getMessageFileName(message)}
          fileUrl={message.url}
          size={message.size || 0}
          isDownload={isDownload}
          closeModal={() => {
            if (ele) {
              ReactDOM.unmountComponentAtNode(ele);
              ele.remove();
            }
          }}
        />
      )}
    </Modal>
  );
  ReactDOM.render(MyModal, ele);
};

export const getVideoModal = (message: any) => {
  // 点击聊天中视频播放按钮时触发
  let previewVideoVisible = false;
  if (isFocusEnv()) {
    const videoMessage = message as VideoMessage;
    if (videoMessage.url) {
      const imgSrc = getFileUrl(videoMessage.thumbnail);
      const videoSrc = message.downLocalPath || getFileUrl(videoMessage.url);
      FocusSDK.viewVideo({
        source: videoSrc,
        poster: imgSrc
      });
    }
  } else {
    previewVideoVisible = true;
  }

  const ele = document.createElement("div");
  document.body.appendChild(ele);
  const MyModal = (
    <Modal
      destroyOnClose={true}
      keyboard={false}
      mask={false}
      footer={null}
      centered
      visible={previewVideoVisible}
      wrapClassName="web-view-video-modal-wrap"
    >
      <div className="preview-web-image-close">
        <IconFont
          type="iconapp_btn_file_cancel"
          onClick={(e: any) => {
            // e.stopPropagation();
            // previewVideoVisible = false;
            if (ele) {
              ReactDOM.unmountComponentAtNode(ele);
              ele.remove();
            }
          }}
        />
      </div>
      <video
        controls
        loop={false}
        width="520"
        height="466"
        className="web-video"
        onClick={() => {
          return false;
        }}
        onDoubleClick={() => {
          return false;
        }}
        muted
        autoPlay={false}
        disablePictureInPicture
      >
        <source src={changeEgovUrl(getFileUrl((message as VideoMessage).url))} type="video/mp4" />
      </video>
    </Modal>
  );
  ReactDOM.render(MyModal, ele);
};

const getMessageItemProps = (message: any): any => {
  return {
    message: message
  };
};

/**
 * 解析template-video格式
 * @param message
 */
const getMergeVideoProps = (message: any): any => {
  if (message?.data?.length) {
    const video = message?.data[0]?.video;
    if (video) {
      return {
        size: video.size || 0,
        thumbHeight: video.thumbHeight || 0,
        thumbWidth: video.thumbWidth || 0,
        thumbnail: video.imageUrl || "",
        url: video.videoUrl || ""
      };
    }
  }
  return {};
};

/**
 * 解析template-location格式
 * @param message
 */
const getMergeLocationProps = (message: any): any => {
  if (message?.data?.length) {
    const location = message?.data[0]?.location;
    if (location) {
      return {
        title: location.title,
        url: location.url,
        image: location.image,
        locationX: location.locationX,
        locationY: location.locationY,
        label: location.label
      };
    }
  }
  return {};
};
/* eslint complexity: ["error", 22] */
// eslint-disable-next-line complexity
export const getChatMessageNode = (
  modalMessages: any[],
  message: any,
  isMergeForward?: boolean,
  originMessage?: any
  // eslint-disable-next-line max-params
): ReactNode => {
  const isSupport = checkMessageSupport(message);
  // if (!isSupport) {
  //     return <UnSupport message={message} />;
  // }
  const isOldStyle = !message.extend?.messageFormatVer || message.extend?.messageFormatVer === "v1";
  const props = getMessageItemProps(message);
  if (message.revoke === 1) {
    // 该消息已撤回
    return <Revoke {...props} />;
  }
  // 兼容老版本
  if (message.kind === ChatMessageType.JOYSPACEFILE) {
    const contentArr = convertContentToArray(message.content);
    // console.log(contentArr, 'contentArrcontentArrcontentArrcontentArr');
    const shortLinkArr = contentArr.filter((item: any) => item.type === MessageCardType.ShortLink);
    // console.log(shortLinkArr, 'shortLinkArrshortLinkArrshortLinkArr');
    if (shortLinkArr.length > 1) {
      message.kind = ChatMessageType.TEXT;
    }
    // console.log(message, 'messagemessagemessagemessage==>');
    // message.content
  }
  switch (message.kind) {
    case ChatMessageType.JOYSPACEFILE:
      return <JoyspaceFile {...props} />;
    case ChatMessageType.JOYSPACEFOLDER:
      return <JoyspaceFolder {...props} />;
    case ChatMessageType.TEXT:
      if (props.message.replyMsgs) {
        props.message.replyMsgs = null;
      }
      if ((message as any).nativeId === "share_link") {
        return <HttpCard {...props} isforward={true} />;
      }
      if ((message as any).meetingCard && (message as any).meetingCard.meetingId) {
        return <MeetingInviteCard {...props} />;
      }
      return <Text {...props} isMergeForward={isMergeForward} modalMessages={modalMessages} />;
    case ChatMessageType.IMAGE:
      return <Image isMergeForward={isMergeForward} modalMessages={modalMessages} {...props} />;
    case ChatMessageType.FILE:
      if (props.sendType === MessageSendType.OWNER || props.sendType === MessageSendType.SELF) {
        if (!isSameClient(message)) {
          return (
            <DownloadFile
              isMergeForward={isMergeForward}
              originMessage={originMessage}
              {...props}
            />
          );
        } else {
          return (
            <UploadFile isMergeForward={isMergeForward} originMessage={originMessage} {...props} />
          );
        }
      } else {
        return (
          <DownloadFile isMergeForward={isMergeForward} originMessage={originMessage} {...props} />
        );
      }
    case ChatMessageType.EGOV_FILE:
      message.type = message.kind;
      if (props.sendType === MessageSendType.OWNER || props.sendType === MessageSendType.SELF) {
        if (!isSameClient(message)) {
          return (
            <DownloadFile
              isMergeForward={isMergeForward}
              originMessage={originMessage}
              {...props}
            />
          );
        } else {
          return (
            <UploadFile isMergeForward={isMergeForward} originMessage={originMessage} {...props} />
          );
        }
      } else {
        return (
          <DownloadFile isMergeForward={isMergeForward} originMessage={originMessage} {...props} />
        );
      }
    case ChatMessageType.VIDEO:
      return <Video isMergeForward={isMergeForward} originMessage={originMessage} {...props} />;
    case ChatMessageType.VOICE:
      return <Voice {...props} content="音频" />;
    case ChatMessageType.TEMPLATE:
      if (message?.template?.nativeId === "video") {
        const video = getMergeVideoProps(message);
        const videoProps = {
          message: { ...props.message, ...video }
        } as any;
        return (
          <Video isMergeForward={isMergeForward} originMessage={originMessage} {...videoProps} />
        );
      }
      if (message?.template?.nativeId === "location_jd") {
        const location = getMergeLocationProps(message);
        const locationProps = {
          message: { ...props.message, ...location }
        } as any;
        return <Location {...locationProps} />;
      }
      return <Share {...props} isMergeForward={isMergeForward} />;
    case ChatMessageType.TEMPLATE2:
      return <Share {...props} isMergeForward={isMergeForward} />;
    case "unified_notice_message":
      if (!isOldStyle) {
        return <AINoticeCard {...props} />;
      }
      return <NoticeCard {...props} />;
    case ChatMessageType.SYS: {
      return <SysMessage {...props} />;
    }
    case ChatMessageType.LOCATION_JD:
      return <Location {...props} />;
    default:
      return null;
  }
};

export const getHeadPortrait = (message: any): ReactNode => {
  return (
    <HeadPortrait
      width="32px"
      height="32px"
      imgUrl={message.senderUrl}
      name={message.senderName}
      isUnFollow={true}
    />
  );
};

export const getShowTime = (message: any) => {
  const { timestamp } = message;
  return getMessageDateFormat(timestamp, MessageDateFormType.DATE_AGGREGATION);
};

export const TimeTransform = (datetime: any) => {
  let getDate: any = new Date(datetime).getDate();
  let getMonth: any = new Date(datetime).getMonth() + 1;
  let getFullYear = new Date(datetime).getFullYear();
  if (String(getMonth).length < 2) {
    getMonth = "0" + getMonth;
  }
  if (String(getDate).length < 2) {
    getDate = "0" + getDate;
  }
  return `${getFullYear}-${getMonth}-${getDate}`;
};

export const openShareUserCard = (message: JoySpaceDocumentMessage) => {
  const cardInfo = lodashGet(message, "data.0.sharecard", {});
  const data = {
    userId: cardInfo?.pin,
    teamId: cardInfo?.teamId,
    app: cardInfo?.app
  } as any;
  openUserCardModal(data);
};

export const openShareCommonCard = (message: JoySpaceDocumentMessage, from?: number) => {
  const { sharelink } = message.data[0] || {};
  if (!sharelink.url) {
    return;
  }
  // 日程需要区分分享的详细来源，是聊天的IM窗口还是日程详情的IM窗口故增加from参数标记
  DeeplinkEvent.open(replaceGovUrl(sharelink.url), { source: "imShareCard", from: from });
};

export const checkFilesLocal = (path: string): Promise<boolean> => {
  return new Promise((resolve) => {
    if (!path) {
      resolve(false);
    }
    FocusSDK.checkLocalPathExist(path, (exists: boolean) => {
      resolve(exists);
    });
  });
};

export const getFileFolderPath = (filePath: string) => {
  return detectOS() === "Win"
    ? filePath.split("\\").slice(0, -1).join("\\")
    : filePath.split("/").slice(0, -1).join("/");
};

export const viewUploadFile = async ({
  message,
  t,
  updateSessionMessageMid,
  expiredTime,
  folderPath,
  currentEmployee,
  selectedSession
}: {
  message: any;
  t: any;
  updateSessionMessageMid: Function;
  expiredTime: number;
  folderPath?: string;
  currentEmployee?: Employee;
  selectedSession: Session;
}) => {
  const fileMessage = message as FileChatMessage;
  if (isFocusEnv()) {
    let exists = await checkFilesLocal(fileMessage.upLocalPath);
    if (!exists) {
      exists = await checkFilesLocal(fileMessage.downLocalPath);
      if (exists) {
        folderPath
          ? FocusSDK.showItemInFolder(fileMessage.downLocalPath)
          : FocusSDK.openItem(fileMessage.downLocalPath);
      } else {
        const isExpired = checkFileIsExpired({
          // expiredAppKey: imAppKey,
          message: fileMessage,
          updateSessionMessageMid,
          expiredTime
        });
        if (!FocusSDK.isPrivateNet() && message.type === ChatMessageType.EGOV_FILE) {
          toast.error(t("egov-file-notice"));
          return;
        }
        console.log("isExpired=>", isExpired);
        if (isExpired) return;
        // toast.error(t('find-file-failed-and-upload'));
        downloadReplyFile({
          fileMessage,
          t,
          currentEmployee,
          openFolder: !!folderPath,
          updateSessionMessageMid,
          selectedSession
        });
      }
    } else {
      // FocusSDK.openItem(
      //     folderPath ? getFileFolderPath(fileMessage.upLocalPath) : fileMessage.upLocalPath
      // );
      folderPath
        ? FocusSDK.showItemInFolder(fileMessage.upLocalPath)
        : FocusSDK.openItem(fileMessage.upLocalPath);
    }
  } else {
    const isExpired = checkFileIsExpired({
      // expiredAppKey: imAppKey,
      message: fileMessage,
      updateSessionMessageMid,
      expiredTime
    });
    if (isExpired) return;
    if (!FocusSDK.isPrivateNet() && message.type === ChatMessageType.EGOV_FILE) {
      toast.error(t("egov-file-notice"));
      return;
    }
    const name = getMessageFileName(message);
    const url = await addXclient(getFileUrl(message.url));
    downLoadFile(name, url, "", {
      onFinish: () => {
        handleAddFileDownloadRecord(message, currentEmployee, 0, selectedSession);
      }
    });
  }
};

export const downloadReplyFile = async ({
  fileMessage,
  t,
  currentEmployee,
  openFolder,
  selectedSession,
  updateSessionMessageMid
}: {
  fileMessage: FileChatMessage;
  t: any;
  currentEmployee?: Employee;
  openFolder?: boolean;
  updateSessionMessageMid?: Function;
  selectedSession: Session;
}) => {
  const saveName = getMessageFileName(fileMessage);
  const url = await addXclient(getFileUrl(fileMessage.url));
  let currDownload: DownloadItem;
  FocusSDK.downloadFile(url, {
    saveAs: false,
    filename: saveName,
    // defaultPath: isFocusEnv()
    //     ? defaultPath
    //     : localStorage.getItem('downloadFilePath') || undefined,
    filter: getFileFilter(fileMessage),
    onStarted: (downloadItem: DownloadItem) => {
      currDownload = downloadItem;
    },
    onProgress: async (progress) => {
      if (progress.status === "interrupted") {
        const fileXhr = await getDownloadFileResp(url);
        if (fileXhr.status === 404 || fileXhr.response?.indexOf("1017005") > -1) {
          currDownload?.cancel();
          toast.error("当前文件已过期或已被清理");
          const imService = ImService.getInstance();
          imService.updateMessage(fileMessage.sessionId, fileMessage.mid, {
            statusType: MessageStatus.EXPIRED
          });
          if (updateSessionMessageMid) {
            updateSessionMessageMid({
              sessionId: fileMessage.sessionId,
              sendResult: { body: { ...fileMessage, statusType: MessageStatus.EXPIRED } }
            });
          }
        }
      }
    },
    onCancel: () => {},
    onPause: () => {},
    onResume: () => {},
    onFinish: (file: { path: string; filename: string }, data: any) => {
      // tj: 解决保存为头像地址
      if (!checkDownloadFilePathValid(saveName, file)) {
        toast.error(t("failed"));
        return;
      }
      let path = `${data.saveAs}${detectOS() === "Win" ? "\\" : "/"}${data.filename}`;
      // if (openFolder) {
      //     path = getFileFolderPath(path);
      // }
      const imService = ImService.getInstance();
      imService
        .updateLocalPath(fileMessage.sessionId, fileMessage.mid, {
          downLocalPath: path
        })
        .then((result) => {
          if (result) {
            // FocusSDK.openItem(path);
            openFolder ? FocusSDK.showItemInFolder(path) : FocusSDK.openItem(path);
            handleAddFileDownloadRecord(fileMessage, currentEmployee, 0, selectedSession);
          } else {
            toast.error(t("failed"));
          }
        });
      if (updateSessionMessageMid) {
        updateSessionMessageMid({
          sessionId: fileMessage.sessionId,
          sendResult: { body: { ...fileMessage, downLocalPath: path } }
        });
      }
    },
    onError: (error: any) => {
      if (error.errorCode === 1017005) {
        const imService = ImService.getInstance();
        imService.updateMessage(fileMessage.sessionId, fileMessage.mid, {
          statusType: MessageStatus.EXPIRED
        });
        if (updateSessionMessageMid) {
          updateSessionMessageMid({
            sessionId: fileMessage.sessionId,
            sendResult: { body: { ...fileMessage, statusType: MessageStatus.EXPIRED } }
          });
        }
      }
    }
  });
};

export const handleAddFileDownloadRecord = (
  fileMessage: FileChatMessage,
  currentEmployee: Employee | undefined,
  optType: 0 | 1 | 2 = 0,
  selectedSession: Session
) => {
  if (
    currentEmployee &&
    !isEqualEmployee(fileMessage.sender, currentEmployee) &&
    !selectedSession.isSecret
  ) {
    addFileDownloadRecord({
      fileId: fileMessage.id,
      fileName: (fileMessage as any).name,
      fileUrl: fileMessage.url,
      groupId: selectedSession.isGroup ? fileMessage.sessionId : undefined,
      mid: fileMessage.mid,
      senderUserId: fileMessage.sender.userId,
      senderTeamId: fileMessage.sender.teamId,
      senderApp: fileMessage.sender.app,
      optType
    });
  }
};

export const checkFileIsExpired = ({
  message = {},
  updateSessionMessageMid,
  type = "file",
  noToast = false,
  expiredTime,
  expiredAppKey
}: {
  message: FileChatMessage | ImageChatMessage | VideoChatMessage | any;
  updateSessionMessageMid?: Function;
  type?: "file" | "image" | "video";
  noToast?: boolean;
  expiredTime: number;
  expiredAppKey?: string;
}) => {
  console.log("expiredTime=>", expiredTime);
  // getDownloadFileRes(getFileUrl(message.url)).then((res) => {
  //   console.log("getDownloadFileRes=>", res);
  // });
  if (message.statusType === MessageStatus.EXPIRED) {
    if (!noToast) {
      toast.error(i18n.t(`chat:${type}-expired-tip`));
    }
    return true;
  }
  // 新版本按照ducc配置，全部过期，不区分是否为新的appKey
  // const url = getFileUrl(message.url);
  // if (!expiredAppKey || url.indexOf(expiredAppKey) === -1) {
  //   return 0;
  // }
  const nowDate = new Date().getTime();
  const sendTime = message.localSendTimestamp || message.timestamp;
  console.log("nowDate - sendTime=>", nowDate - sendTime > expiredTime);
  if (expiredTime && sendTime && nowDate - sendTime > expiredTime) {
    if (updateSessionMessageMid) {
      const imService = ImService.getInstance();
      imService.updateMessage(message.sessionId, message.mid, {
        statusType: MessageStatus.EXPIRED
      });
      updateSessionMessageMid({
        sessionId: message.sessionId,
        sendResult: { body: { ...message, statusType: MessageStatus.EXPIRED } }
      });
    }
    if (!noToast) {
      toast.error(i18n.t(`chat:${type}-expired-tip`));
    }
    return true;
  }
  return false;
};

export const getDownloadFileRes = async (
  url: string,
  type?: XMLHttpRequestResponseType,
  isNoCache?: boolean
): Promise<any> => {
  return new Promise((resolve) => {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    isNoCache && xhr.setRequestHeader("Cache-Control", "no-cache");
    xhr.responseType = type || "text";
    xhr.onload = function () {
      resolve(this);
    };
    xhr.send();
  });
};

export const getMessageEmojiHasReply = (
  msgContent: any[],
  item: any,
  currentEmployee: Employee
) => {
  if (!msgContent || !msgContent.length || !item) {
    return false;
  }
  const replyItem = msgContent.find((i: any) => i.emojiCode === item.id || i.id === item.id);
  if (!replyItem || !replyItem?.users?.length) {
    return false;
  }
  const hasReply = replyItem.users.find(
    (i: any) => convertEmployeeToString(currentEmployee) === convertEmployeeToString(i)
  );
  return !!hasReply;
};
